// extracted by mini-css-extract-plugin
module.exports = {"sectionSocialMedia":"SectionSocialMedia_sectionSocialMedia_1G08Y"};